import type { RouteConfig, RouteMeta } from '@his/shared';

function joinPaths(parent: string, segment: string): string {
  if (!segment) return parent;
  if (segment.startsWith('/')) return segment;
  const left = parent.endsWith('/') ? parent.slice(0, -1) : parent;
  const right = segment.startsWith('/') ? segment.slice(1) : segment;
  return `${left}/${right}`;
}

export type MobileRouteTitleEntry = { path: string; meta?: RouteMeta };

/**
 * 将嵌套的 mobileRoutes 展平为「完整 path + meta」，供 document.title 与 matchPath 使用。
 */
export function flattenMobileRoutesForTitle(routes: RouteConfig[]): MobileRouteTitleEntry[] {
  const out: MobileRouteTitleEntry[] = [];

  function walk(nodes: RouteConfig[], parentFullPath: string) {
    for (const node of nodes) {
      const fullPath = node.index
        ? parentFullPath
        : node.path.startsWith('/')
          ? node.path
          : joinPaths(parentFullPath, node.path);

      if (node.children?.length) {
        walk(node.children, fullPath);
      }

      const isLeaf = !node.children?.length;
      if (isLeaf || node.index) {
        out.push({ path: fullPath, meta: node.meta });
      }
    }
  }

  walk(routes, '');
  return out;
}
